import styled from 'styled-components';
import tw from 'twin.macro';
import { Body, Meta } from '../../styled components/Typography';

/* DOCUMENTATION
    1. max-w-full: necessary class to make the upper defined class break-words to work for inline-block elements
    2. min-w-0: necessary class to make the higher order defined class `break-words` to work for flex elements
    3. break-words: Let the textual content break in a nice way
*/

export const StyledContainerBreakWords = styled.div(() => [
  tw`break-words min-w-0` /* [1,3] */
]);

export const StyledCustomDataLabel = styled(Body).attrs(() => ({
  as: 'label',
  $color: 'default',
  $textStyle: 'bold'
}))(() => []);

export const StyledCustomDataDescription = styled(Meta).attrs(() => ({
  as: 'p',
  $textStyle: 'italic',
  $color: 'gray dark'
}))(() => [tw`mt-4`]);

/* Checkbox */
export const StyledCheckboxList = styled.ul(() => []);
export const StyledCheckboxListItem = styled.li(() => [
  tw`flex space-x-4 mb-4 break-words`
]);

/* Contact and Resource */
export const StyledObjectName = styled.p(() => [
  tw`inline-block max-w-full mr-4` /* [1] */
]);
export const StyledObjectRole = styled(Meta).attrs(() => ({
  as: 'p',
  $color: 'gray dark'
}))(() => [tw`inline-block max-w-full text-sm` /* [1] */]);
export const StyledContactLinkName = styled(Meta).attrs(() => ({
  as: 'p',
  $color: 'gray dark'
}))(() => []);
export const StyledContactInfoLabel = styled(Meta).attrs(() => ({
  as: 'div',
  $color: 'default'
}))(() => [tw`pr-4 leading-normal flex-shrink-0`]);

/* Attachment */
export const StyledAttachmentDetails = styled(Meta).attrs(() => ({
  as: 'div',
  $color: 'gray dark'
}))(() => []);
